// Frontend metadata for tiers.
// PRODUCT data is now fetched live from /api/catalog (DB-backed, admin-editable).

export const TIERS = [
  {
    id: "start",
    name: "START",
    subtitle: "Benessere & Fondamenta",
    description:
      "La base solida del tuo percorso. Vitamine, minerali e nutrienti essenziali per attivare ogni giorno la tua energia naturale.",
  },
  {
    id: "power",
    name: "POWER",
    subtitle: "Muscolo & Crescita",
    description:
      "Spinta, recupero e costruzione. Le formule che alimentano l'allenamento e accelerano la tua trasformazione fisica.",
  },
  {
    id: "elite",
    name: "ELITE",
    subtitle: "Performance Professionali",
    description:
      "Il vertice della nutrizione sportiva. Formulazioni di precisione per chi non accetta compromessi.",
  },
];
